import FJAppConstant from '../constants/FJAppConstant.js';

const FJAIToolUtil = {
    getVideoAppTypeList: function () {
        return [FJAppConstant.AI_VIDEO_GENERATOR, FJAppConstant.VIDEO_REMOVE_BG, FJAppConstant.AI_VIDEO_DUB];
    },
};
export default FJAIToolUtil;
